export default __webpack_public_path__ + "static/media/email.777fea54.svg";